import React, { useEffect, useState } from "react";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import { Box } from "@mui/material";
import Loader from "../common/loader";
import { useAuth } from "../../context/AuthContext";

const Layout = ({ children, displayLoader, disableHeaderSelection , onYearPickerChange}) => {
    const [loading, setLoading] = useState(displayLoader);
    const { user } = useAuth();

    useEffect(() => {
        setLoading(displayLoader);
    }, [displayLoader]);

    return (
        <Box sx={{ display: "flex" }}>
            <Header user={user} disableSelection={disableHeaderSelection} onYearPickerChange={onYearPickerChange} />
            <Sidebar user={user} />
            <main className="flex-grow px-5 pt-1 overflow-auto bg-background h-screen relative">
                <div className="flex items-center justify-end min-h-[45px]" />
                {loading && <Loader isFullPage={true} />}
                {children}
            </main>
            {/* <Footer /> */}
        </Box>
    );
};

export default Layout;
